import { Pipe, PipeTransform } from '@angular/core';
import {DomSanitizer, SafeResourceUrl} from "@angular/platform-browser";

@Pipe({
  name: 'safeUrl',
  standalone: false
})
export class SafeUrlPipe implements PipeTransform {

  constructor(private readonly sanitizer: DomSanitizer) {}

  /**
   * Transforms a URL by bypassing Angular's built-in sanitization.
   * 
   * SECURITY: This pipe should only be used with URLs from trusted sources
   * (e.g., internal APIs, validated configuration). Never use with user-provided
   * or external untrusted URLs as it may lead to XSS vulnerabilities.
   * 
   * @param url - The trusted URL to transform
   * @returns SafeResourceUrl that can be used in Angular templates
   */
  transform(url: string): SafeResourceUrl {
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }

}
